export default class ContactTab {
  constructor() {
    this.$ContactTab = $('div.contact-tab');
    this.$html = $('html');

    this.$toggels = $('div.contact-tab label[for=\'contact-form\'], div.contact-tab .btn-close');
  }

  init() {
    this.$toggels.click(() => {
      this.$ContactTab.toggleClass('open');
      this.$html.toggleClass('contact-tab-open');
    });
  }
}
